import React, { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import "./HeroSection.css";

const HeroSection = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section" ref={heroRef} aria-labelledby="hero-headline">
      <div className="hero-background" aria-hidden="true">
        <div className="hero-overlay"></div>
        <img
          src="https://images.unsplash.com/photo-1510906594845-bc082582c8cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzcwMTI3NDg3fDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="hero-image"
          width="1920"
          height="1280"
          fetchPriority="high"
          decoding="async"
        />
      </div>
      <div className="hero-content">
        <h1 className="hero-headline" id="hero-headline">
          UNCONVENTIONAL VISION.{" "}
          <br />
          <span className="hero-headline-accent">UNRIVALED IMPACT.</span>
        </h1>
        <p className="hero-subheadline">
          Oddtive is a media production agency crafting cinematic brand films, product ads and social media campaigns for world-changing brands.
        </p>
        <div className="hero-cta-group">
          <button onClick={scrollToContact} className="btn-primary magnetic">
            Start the Production
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
      <div className="hero-grain"></div>
    </section>
  );
};

export default HeroSection;